export default __webpack_public_path__ + "static/media/comingSoon.e5ed0ba1.png";